/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Guvenlik_TitleInputs */

const tr_faq_cat_guvenlik_title = /** @type {(inputs: Faq_Cat_Guvenlik_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenlik ve Hesap`)
};

const en_faq_cat_guvenlik_title = /** @type {(inputs: Faq_Cat_Guvenlik_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security & Account`)
};

const de_faq_cat_guvenlik_title = /** @type {(inputs: Faq_Cat_Guvenlik_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheit und Konto`)
};

const ru_faq_cat_guvenlik_title = /** @type {(inputs: Faq_Cat_Guvenlik_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасность и аккаунт`)
};

/**
* | output |
* | --- |
* | "Security & Account" |
*
* @param {Faq_Cat_Guvenlik_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_guvenlik_title = /** @type {((inputs?: Faq_Cat_Guvenlik_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Guvenlik_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_guvenlik_title(inputs)
	if (locale === "de") return de_faq_cat_guvenlik_title(inputs)
	if (locale === "ru") return ru_faq_cat_guvenlik_title(inputs)
	return tr_faq_cat_guvenlik_title(inputs)
});